export default __webpack_public_path__ + "static/media/sassoon.12183e4b.svg";